import { getFormattedNumber } from './getFormattedNumber';

export const getFormattedPrice = (price: number | string) => `${getFormattedNumber(price)} kr`;
